import React from 'react'
import { ChevronRightIcon } from '@heroicons/react/24/solid'
import { TopSellingCard } from './TopSellingCard'
import { useQuery } from '@tanstack/react-query'
import { handleGetRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/free-mode'

export const TopSellingSection = () => {
  const { data: topSellingProductsData } = useQuery({
    queryKey: QueryKeys.topSellingProducts(),
    queryFn: () => handleGetRequest('/top-products'),
  })
  const topSellingProducts = topSellingProductsData?.data || []

  if (topSellingProducts.length === 0) {
    return null
  }

  return (
    <div className="bg-blue-700 py-4 main-container">
      <div className="flex justify-between items-center mb-2">
        <h2 className="text-lg font-extrabold text-white capitalize">
          Top Selling Products Last Month
        </h2>
        <Link to="/products" aria-label="View all top selling items">
          <ChevronRightIcon className="h-6 w-6 text-secondary-600" />
        </Link>
      </div>

      <div className="py-4">
        <Swiper
          modules={[FreeMode]}
          spaceBetween={16}
          slidesPerView="auto"
          freeMode={{
            enabled: true,
            sticky: false,
          }}
          watchSlidesProgress={true}
          className="swiper-container"
          breakpoints={{
            320: {
              slidesPerView: 2.5,
              spaceBetween: 12,
            },
            640: {
              slidesPerView: 3.5,
              spaceBetween: 16,
            },
            768: {
              slidesPerView: 4.5,
              spaceBetween: 16,
            },
          }}
        >
          {topSellingProducts.map((item) => (
            <SwiperSlide key={item.id} className="!w-auto">
              <TopSellingCard item={item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}
